<div class="mt-6">
  <app-page-header
    [pageTitle]="'Listado de contactos del prospecto'"
    [showCreateButton]="(showCreateButton && !selectionMode) && permissionAuth.canCreate('prospectos')"
    [textButton]="'Nuevo contacto'"
    (onCreateClick)="openCreateModal()"
  />

  <!-- Filtros -->
  <app-filters-container
    [hasData]="contactos.length > 0"
    [hasActiveFilters]="hasActiveFilters"
    [loading]="loading"
    (clearFilters)="clearFilters()"
  >
    <app-filter-select
      label="Canal de contacto"
      [value]="filtros.param_canal_contacto_id"
      [options]="canalesContactoOptions"
      (valueChange)="onCanalContactoChange($event)"
    />

    <app-filter-select
      label="Motivo de contacto"
      [value]="filtros.param_motivo_contacto_id"
      [options]="motivosContactoOptions"
      (valueChange)="onMotivoContactoChange($event)"
    />

    <app-filter-select
      label="Campaña"
      [value]="filtros.crm_campanha_id"
      [options]="campanhasOptions"
      (valueChange)="onCampanhaChange($event)"
    />

    <app-filter-select
      label="Presupuesto"
      [value]="filtros.tiene_presupuesto_enviado"
      [options]="tienePresupuestoOptions"
      (valueChange)="onTienePresupuestoChange($event)"
    />

    <app-filter-date
      label="Fecha desde"
      [value]="filtros.fecha_desde"
      (valueChange)="onFechaDesdeChange($event)"
    />

    <app-filter-date
      label="Fecha hasta"
      [value]="filtros.fecha_hasta"
      (valueChange)="onFechaHastaChange($event)"
    />
  </app-filters-container>

  <!-- Tabla -->
  <app-data-table
    [columns]="columns"
    [data]="contactos"
    [loading]="loading"
    [emptyTitle]="'No hay contactos registrados'"
    [emptySubtitle]="'Prueba ajustando los filtros o crea un nuevo contacto'"
    (rowClick)="onRowClick($event)"
  >
    <!-- Motivo -->
    <ng-template appTableCell="motivo" let-contacto>
      <div class="flex flex-col">
        <span>{{ contacto.motivo_contacto }}</span>
        <small class="text-gray-500 dark:text-gray-400">CANAL: {{ contacto.canal_contacto }}</small>
      </div>
    </ng-template>

    <!-- Campaña -->
    <ng-template appTableCell="campanha" let-contacto>
      <div class="flex flex-col">
        <span>{{ contacto.campanha }}</span>
        <small class="text-gray-500 dark:text-gray-400">Inicio: {{ contacto.campanha_fecha_inicio | date: 'dd/MM/yyyy' }}</small>
        <small class="text-gray-500 dark:text-gray-400">Fin: {{ contacto.campanha_fecha_fin | date: 'dd/MM/yyyy' }}</small>
      </div>
    </ng-template>

    <!-- Fecha -->
    <ng-template appTableCell="fecha" let-contacto>
      {{ contacto.fecha | date: 'dd/MM/yyyy' }}
    </ng-template>

    <!-- Resultado -->
    <ng-template appTableCell="resultado" let-contacto>
      {{ contacto.resultado }}
    </ng-template>

    <!-- Estado -->
    <ng-template appTableCell="estado" let-contacto>
      {{ contacto.estado_contacto }}
    </ng-template>

    @if (!selectionMode) {
      <!-- Acciones -->
      <ng-template appTableCell="acciones" let-contacto let-index="index">
        <div class="flex items-center gap-x-2">
          <button
            (click)="openViewModal(contacto.id); $event.stopPropagation()"
            [matTooltip]="'Ver contacto'"
          >
            <mat-icon class="dark:text-gray-400!">visibility</mat-icon>
          </button>

          <button
            (click)="openServiciosModal(contacto.id); $event.stopPropagation()"
            [matTooltip]="'Ver servicios asociados'"
          >
            <mat-icon class="dark:text-gray-400!">medical_services</mat-icon>
          </button>

          <button *hasPermission="'prospectos:create'"
            (click)="generar(contacto.id); $event.stopPropagation()"
            [matTooltip]="contacto.propuesta_activa_id ? 'Ya tiene una propuesta activa' : 'Generar propuesta comercial'"
            [disabled]="contacto.propuesta_activa_id"
            [class.opacity-40]="contacto.propuesta_activa_id"
            [class.cursor-not-allowed]="contacto.propuesta_activa_id"
          >
            <mat-icon class="dark:text-gray-400!">note_add</mat-icon>
          </button>

          @if (contacto.propuesta_activa_id && contacto.propuesta_activa_path) {
            <button
              (click)="descargarPropuesta(contacto.propuesta_activa_id); $event.stopPropagation()"
              [matTooltip]="'Descargar propuesta activa'"
            >
              <mat-icon class="dark:text-gray-400!">download</mat-icon>
            </button>
          }

          <!--
          <app-delete-trigger *hasPermission="'prospectos:delete'"
            [title]="'Eliminar contacto'"
            [disabled]="deleting && (index === deletingIndex)"
            (clickDeleteEvent)="delete(contacto.id, index); $event.stopPropagation()"
          />
          -->
        </div>
      </ng-template>
    }
  </app-data-table>

  <!-- Paginación -->
  <app-pagination
    [currentPage]="currentPage"
    [lastPage]="lastPage"
    [perPage]="perPage"
    [total]="total"
    (pageChange)="onPageChange($event)"
    (perPageChange)="onPerPageChange($event)"
  />
</div>

<!-- Sección de servicios comentada - será rediseñada -->
<!--
<ng-template #rowServicesTemplate let-contacto>
  <div class="overflow-hidden shadow-lg">
    <div class="px-8 py-4 border-b">
      <app-contactos-servicios [idContacto]="contacto.id" />
    </div>
  </div>
</ng-template>
-->
